import React, {useState, useCallback} from 'react';
import Dropdown from 'react-dropdown';

export default function SamplesPerNote(props) {
    let {resampleConfig} = props.sequencerEngine;
    let [samplesPerNote, setSamplesPerNote] = useState(resampleConfig.samplesPerNote);

    const getOptions = (total=8) => {
        let options = [];
        for (let i=1; i <= total; i++) {
            options.push({label: i, value: i});
        }
        return options;
    };

    let selectedOption = {
        label: resampleConfig.samplesPerNote,
        value: resampleConfig.samplesPerNote
    };

    const onChange = useCallback((value) => {
        resampleConfig.samplesPerNote = value;
        setSamplesPerNote(value);
    }, [setSamplesPerNote]);

    return (
        <div className="samples-per-note">
          <div className="dropdown-label">
            Samples Per Note:
          </div>
          <Dropdown
            className='osc-type-dropdown'
            controlClassName='osc-type-control-dropdown'
            arrowClassName='osc-type-arrow-dropdown'
            options={getOptions()}
            onChange={o => onChange(o.value)}
            value={selectedOption}
            placeholder="Samples per note" />
        </div>
    );
}
